import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { downloadSampleFile } from './downloadSampleFile';
import { ReportKey } from './reportColumnConfig';

type SampleAction = {
    report: ReportKey;
    download: () => void;
    upload?: () => void;
    uploadReady?: boolean;
};

const SampleFileSetterContext = createContext<(action: SampleAction | null) => void>(() => {});
const SampleFileActionContext = createContext<SampleAction | null>(null);

export function SampleFileProvider({ children }: { children: ReactNode }) {
    const [action, setAction] = useState<SampleAction | null>(null);
    return (
        <SampleFileSetterContext.Provider value={setAction}>
            <SampleFileActionContext.Provider value={action}>{children}</SampleFileActionContext.Provider>
        </SampleFileSetterContext.Provider>
    );
}

/** The open report registers its sample file. Leaving the report clears it. */
export function useRegisterSampleFile(
    report: ReportKey,
    customHeaders: string[],
    upload?: () => void,
    uploadReady = false,
    active = true
) {
    const setAction = useContext(SampleFileSetterContext);
    const headerKey = customHeaders.join('\0');
    useEffect(() => {
        if (!active) {
            setAction(null);
            return;
        }
        const headers = headerKey ? headerKey.split('\0') : [];
        setAction({
            report,
            download: () => downloadSampleFile(report, headers),
            upload,
            uploadReady,
        });
        return () => setAction(null);
    }, [setAction, report, headerKey, upload, uploadReady, active]);
}

export function useSampleFileAction() {
    return useContext(SampleFileActionContext);
}
